// Admin bottom nav · 7 tabs (音檔 / 地圖 / 訊息 / 碎片 / 學員 / 探索 / 迴響).
// 2026-05-30: dropped the horizontal scroll-snap (workers are all on
// iPhone 11+, 390px+). 2026-06-02: added 迴響 (post-event echo overview).
// 7 tabs are tight on 390px — per-tab padding tightened below to fit; if a
// future worker is on a narrow device, revisit (the EN sub-labels are the
// first thing to drop).

import { T } from "@goodbye/ui";
import { useLocation, useNavigate } from "react-router-dom";

const items = [
  { id: "audio", zh: "音檔", en: "AUDIO", path: "/audio" },
  { id: "map", zh: "地圖", en: "MAP", path: "/map" },
  { id: "messages", zh: "訊息", en: "TEXT", path: "/messages" },
  { id: "fragments", zh: "碎片", en: "PIECE", path: "/fragments" },
  { id: "users", zh: "學員", en: "USERS", path: "/users" },
  { id: "regions", zh: "探索", en: "PLACES", path: "/regions" },
  { id: "echoes", zh: "迴響", en: "VOICE", path: "/echoes" },
];

export function AdminNav() {
  const nav = useNavigate();
  const { pathname } = useLocation();

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        // Leaflet's panes climb to z-index 700+. Without an explicit
        // z-index here, the map pane sits on top and visually swallows
        // the nav on /map.
        zIndex: 10,
        borderTop: `1px solid ${T.ink100}`,
        background: T.paper,
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
      }}
      role="tablist"
      aria-label="工作員主選單"
    >
      <div
        style={{
          padding: "10px 6px 14px",
          display: "flex",
          flexWrap: "nowrap",
          justifyContent: "center",
          alignItems: "baseline",
          // 7 tabs on 390px: tightened from gap 6 to 4 to fit the row.
          gap: 4,
        }}
      >
        {items.map((it, i) => {
          const active = pathname.startsWith(it.path);
          return (
            <span
              key={it.id}
              style={{
                display: "inline-flex",
                alignItems: "baseline",
                gap: 6,
                flexShrink: 0,
              }}
            >
              {i > 0 && (
                <span style={{ color: T.ink200, fontFamily: T.mono }}>·</span>
              )}
              <button
                onClick={() => nav(it.path)}
                role="tab"
                aria-selected={active}
                style={{
                  padding: "8px 3px",
                  minHeight: 44,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                  color: active ? T.ink900 : T.ink350,
                  background: "transparent",
                  border: "none",
                  borderBottomColor: active ? T.ink900 : "transparent",
                  borderBottomStyle: "solid",
                  borderBottomWidth: 1,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                <span
                  style={{ fontFamily: T.han, fontSize: 12, fontWeight: 300 }}
                >
                  {it.zh}
                </span>
                <span
                  style={{
                    fontFamily: T.mono,
                    fontSize: 10,
                    letterSpacing: "0.16em",
                  }}
                >
                  {it.en}
                </span>
              </button>
            </span>
          );
        })}
      </div>
    </div>
  );
}
